import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-behind-square-1, copy 1, layers, pages"><path fillRule="evenodd" clipRule="evenodd" d="M2 5C2 3.34315 3.34315 2 5 2H13C14.6569 2 16 3.34315 16 5V8H19C20.6569 8 22 9.34315 22 11V19C22 20.6569 20.6569 22 19 22H11C9.34315 22 8 20.6569 8 19V16H5C3.34315 16 2 14.6569 2 13V5ZM14.5 8H11C9.34315 8 8 9.34315 8 11V14.5H5C4.17157 14.5 3.5 13.8284 3.5 13V5C3.5 4.17157 4.17157 3.5 5 3.5H13C13.8284 3.5 14.5 4.17157 14.5 5V8Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSquareBehindSquare1;
